module.exports = __webpack_public_path__ + "img/bg.cc946eb0.png";